import React from 'react';
import { ModalContainer } from '@welbe/web-design-system';
import { useNavigate } from 'react-router';
import { Wrapper, Title, Description } from './NotAuthorized.styles';
import { ReactComponent as SadFaceIcon } from 'App/assets/img/sad-face.svg';
import { Button } from '@welbe/design-system';

const NotAuthorized = () => {
	const navigate = useNavigate();

	return (
		<ModalContainer
			visible
			closeOnlyOnTheButton
			height={220}
			borderRadius="4px"
		>
			<Wrapper>
				<SadFaceIcon width={33} height={31} />
				<Title>Sin permiso de acceso</Title>
				<Description>
					Lo sentimos, si requieres acceder a esta sección, contacta con el
					administrador para habilitar el permiso.
				</Description>
				<Button onClick={() => navigate(-1)}>Regresar</Button>
			</Wrapper>
		</ModalContainer>
	);
};

export default NotAuthorized;
